import React from 'react';

const Logo = ({ size = 'normal', onClick }) => {
  const isLarge = size === 'large';
  
  return (
    <div className={`brand-logo ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
      <div className={`shield-icon ${isLarge ? 'large' : ''}`} style={!isLarge ? { transform: 'scale(0.8)' } : {}}>
        <span className="shield-char">F</span>
      </div>
      <div className={`leading-${isLarge ? 'none' : 'tight'}`}>
        <h1 className={`font-serif font-bold ${isLarge ? 'text-5xl' : 'text-xl md:text-2xl'} text-crimson tracking-tight`}>
          {isLarge ? 'FIT' : 'FIT'}
        </h1>
        <p className={`text-[${isLarge ? '12px' : '10px'}] uppercase tracking-widest text-slate font-bold ${isLarge ? 'mt-2' : ''}`}>
          Engineering College
        </p>
      </div>
    </div>
  );
};

export default Logo;